import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"max-width":"300px","font-size":"14px","white-space":"pre-line"} }


import { QuestionFilled } from '@element-plus/icons-vue'

export default /*#__PURE__*/_defineComponent({
  props: ['content'],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    placement: "top",
    effect: "light"
  }, {
    content: _withCtx(() => [
      _createElementVNode("pre", _hoisted_1, "        " + _toDisplayString(__props.content) + "\n      ", 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_icon, { color: "#999" }, {
        default: _withCtx(() => [
          _createVNode(_unref(QuestionFilled))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})